<template>
  <div id="Recharge" class="m-consumption">
    <div class="u-toptilte">
      <p><i style="color:#FFCC00">▎</i>返佣记录</p>
    </div>

    <section v-if="!zanwusj">
      <el-table :data="chongzhiData">
        <el-table-column
          label="返佣金额"
          prop="num"
          align="center"
        ></el-table-column>
        <el-table-column
          label="描述"
          prop="desc"
          align="center"
        ></el-table-column>
        <el-table-column label="时间" prop="createdat" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.createdat
                .split("T")
                .join(" ")
                .split("+")
                .shift()
            }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="u-btnpage">
        <span>共{{ gongye }}页</span>
        <span>当前{{ dangqianye }}页</span>
        <a @click="shang">上一页</a>

        <a @click="xia">下一页</a>
      </div>
    </section>
    <div v-if="zanwusj" class="no-Order">
      <img draggable="false" src="../../static/percttent/nodd.png" />
      <p>暂无充值记录！</p>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title:'海星云充值记录，云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      zanwusj: true,
      token: '',
      chongzhiData: '',
      dangqianye: '',
      gongye: ''
    }
  },
  methods: {
    shang () {
      this.dangqianye = this.dangqianye - 1
      this.http.sxye(this.dangqianye, 4).then(res => {
        this.chongzhiData = res.data.data.charge_list
      })
      if (this.dangqianye < 1) {
        this.dangqianye = 1
        return false
      }
    },
    xia () {
      this.dangqianye = this.dangqianye + 1
      this.http.sxye(this.dangqianye, 4).then(res => {
        this.chongzhiData = res.data.data.charge_list
      })
      if (this.dangqianye > this.gongye) {
        this.dangqianye = this.gongye
        return false
      }
    }
  },
  mounted () {
    this.token = this.$cookieStore.getCookie('user_sess')
    if (!this.token) {
      this.$message({
        message: '抱歉！您还没登录',
        type: 'warning'
      })
      return false
    } else {
      this.http.chongzhijl(4).then(res => {
        this.chongzhiData = res.data.data.charge_list
        if (this.chongzhiData.length == 0) {
          this.zanwusj = true
        } else {
          this.zanwusj = false
        }
        this.dangqianye = res.data.data.cur_page
        this.gongye = res.data.data.total_page
      })
    }
  }
}
</script>
<style scoped>
/* #Recharge {
  width: 838px;
  height: 792px;
  border: 15px solid #fff;
  background: rgba(242, 242, 242, 1);
  border-radius: 13px;
  position: relative;
}
#Recharge > p {
  height: 80px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(41, 92, 164, 1);
  line-height: 80px;
  padding: 0 20px;
  border-bottom: 2px solid #fff;
}
#Recharge > p img {
  margin-right: 20px;
  vertical-align: middle;
}
.czjilu {
  overflow: hidden;
  border-bottom: 2px solid #fff;
}
.czjilu p {
  font-size: 24px;
  color: rgba(41, 92, 164, 1);
  height: 75px;
  line-height: 75px;
  text-align: center;
}
#Recharge ul li {
  overflow: hidden;
  border-bottom: 2px solid #fff;
  height: 75px;
}
#Recharge ul li p {
  text-align: center;
  font-size: 20px;
  color: rgba(43, 43, 43, 1);
  line-height: 75px;
}
#Recharge .btn {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  padding: 30px 6.25rem 30px 1.875rem;
}
#Recharge .btn span {
  display: inline-block;
  width: 3.125rem;
  border: 1px solid #dfdfdf;
  padding: 6px 1.25rem;
  line-height: 14px;
  border-radius: 13px;
  text-align: center;
  background: #fff;
  color: #3c3c3c;
  transition: background-color 0.5s;
  margin-left: 80px;
}
#Recharge .btn span:hover {
  background: #dfdfdf;
} */
</style>



// WEBPACK FOOTER //
// src/components/InviteBonusList.vue